import { Department } from './department.model';
import { StrategicGoal } from './strategic-goal.model';
import { EvaluateItem } from '@masar/features/evaluate/interfaces';
import { FlowItem } from '@masar/features/flow/interfaces';

export type CommitteeFlowState =
    'draft' | 'in_review' | 'approved' | 'active' | 'closed';

export interface CommitteeGoalItem {
    goals: string;
    strategicGoals?: StrategicGoal[];
}

export interface Committee extends FlowItem<CommitteeFlowState>, EvaluateItem {
    id: string;
    name: string;
    nameAr: string;
    nameEn: string;
    type: string;
    category: string;
    startDate: string;
    endDate: string | null;
    tasks?: string;
    goalItems?: CommitteeGoalItem[];
    department: Department;
}

export const committeeCategory = {
    temporary: 'temporary',
    permanent: 'permanent',
    shared: 'shared',
} as const;
